import type { TargetedEvent } from 'preact';
import cn from 'classnames';
import styles from './Chevron.module.scss';

export type ChevronProps = {
  type: 'next' | 'prev';
  onClick: (event: TargetedEvent<HTMLButtonElement>, direction: 1 | -1) => void;
  class?: string;
  a11yLabel: string;
  disabled?: boolean;
};

export default function Chevron({
  type,
  onClick,
  class: className,
  a11yLabel,
  disabled
}: ChevronProps) {
  return (
    <button
      type="button"
      aria-label={a11yLabel}
      tabIndex={0}
      disabled={disabled}
      class={cn(
        type === 'prev' && styles.prev,
        type === 'next' && styles.next,
        className
      )}
      onClick={(e) => onClick(e, type === 'next' ? 1 : -1)}
    />
  );
}
